import { Validator } from 'vee-validate';

const addValidators = function() {

}

export default {
  classNames: {},
  events: 'blur',
  addValidators,
};
